import React from 'react';
import PropTypes from 'prop-types';
import Markup from 'components/Markup';
import { Box, NakedButton } from '@qga/roo-ui/components';
import CancellationRefundSummary from 'components/CancellationRefundSummary';
import { useTooltip } from 'lib/hooks';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

const TooltipWrapper = styled(Box)`
  box-shadow: ${themeGet('shadows.tooltip')};
  color: ${themeGet('colors.greys.steel')};
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.6')} ${themeGet('space.8')};
  border-radius: ${themeGet('radii.default')};
  width: ${themeGet('uiStructure.tooltipWidth')};
  text-align: left;
`;

const CancellationTooltip = ({ cancellationPolicy }) => {
  const description = cancellationPolicy?.description;
  const { triggerProps, tooltipProps, isOpen } = useTooltip('cancellation-policy-button');

  return (
    <NakedButton {...triggerProps}>
      <CancellationRefundSummary cancellationPolicy={cancellationPolicy} />
      {isOpen && (
        <Box {...tooltipProps}>
          <TooltipWrapper>
            <CancellationRefundSummary data-testid="cancellation-type-header" cancellationPolicy={cancellationPolicy} />
            {description && <Markup content={description} mt={4} fontSize="base" color="greys.steel" />}
          </TooltipWrapper>
        </Box>
      )}
    </NakedButton>
  );
};

CancellationTooltip.propTypes = {
  cancellationPolicy: PropTypes.object.isRequired,
};

export default CancellationTooltip;
